import { ApolloError } from '@apollo/client';

type ParsedApolloError = {
  kind: 'graphql' | 'network' | 'unknown';
  code?: string;
  message: string;
  httpStatus?: number;
  extra?: any;
};

export function parseApolloError(error: ApolloError): ParsedApolloError {
  // 1) Errors GraphQL "normal" (HTTP 200)
  const gqlErr = error.graphQLErrors?.[0];
  if (gqlErr) {
    const code = (gqlErr.extensions?.code as string | undefined) ?? undefined;
    const extra = (gqlErr.extensions?.extra as any | undefined) ?? undefined;
    return {
      kind: 'graphql',
      code,
      message: gqlErr.message || 'GraphQL error',
      extra,
    };
  }

  // 2) Errors network (HTTP != 200) but may contain a GraphQL payload
  const netErr = error.networkError as any;
  if (netErr) {
    const status = typeof netErr.statusCode === 'number' ? netErr.statusCode : undefined;

    const bodyGqlErr = netErr.result?.errors?.[0];
    if (bodyGqlErr) {
      const code = (bodyGqlErr.extensions?.code as string | undefined) ?? undefined;
      const extra = (bodyGqlErr.extensions?.extra as any | undefined) ?? undefined;
      return {
        kind: 'graphql',
        code,
        httpStatus: status,
        message: bodyGqlErr.message || netErr.message || 'GraphQL error',
        extra,
      };
    }

    return {
      kind: 'network',
      httpStatus: status,
      message: netErr.message || 'Network error',
    };
  }

  return { kind: 'unknown', message: error.message || 'Unknown error' };
}
